import React, { useEffect, useState } from "react";
import SidebarPopup from "../../Components/SidebarPopup/SidebarPopup";
import { DropDownBox } from "../../Components/SidebarPopup/style";
import verifyIcon from "../../assets/images/verifyIcon.png";
import animationData1 from "../../assets/lotties/question.json";
import ModalData from "../../Components/ModalData/ModalData";
import { isEmpty, isNumber } from "../../utils/common";
import { AlertWrapper } from "../../Components/Modal/style";
import {
  getApproveBank,
  getBankDetails,
  getKucDetails,
  getKycStatus,
  getParentDetails,
  getRejectBank,
  getUserList,
  KycApprove,
  KycReject,
  updateParent,
} from "../../utils/api";
import { ModalPopUp } from "../../Components/ModalPopUp/ModalPopUp";

function UserDaitalsPopup({ data = {}, close = () => {} }) {
  const [event, setEventType] = useState(null);
  const [loader, setLoader] = useState(false);
  const [msg, setMsg] = useState({});
  const [kycData, setKycData] = useState({});
  const [distributorMobile, setDistributorMobile] = useState("");
  const [distributor, setDistributor] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [kycStatus, setKyceStatus] = useState(false);
  const [parentData, setParentData] = useState({});
  const [popupLoader, setPopupLoader] = useState(false);
  const [reload, setReload] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [backDetails, setBackDetails] = useState({});

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };

  const clickHandler = (id, type) => {
    setEventType({ msg: `Do you want to ${type} ${id}?`, type: type, id: id });
  };

  const confirmHandler = () => {
    if (event?.id === "kyc details" && event?.type === "approve") {
      approveKyc();
    } else if (event?.id === "kyc details" && event?.type === "reject") {
      rejectKyc();
    } else if (event?.id === "bank" && event?.type === "reject") {
      rejectBank();
    } else if (event?.id === "bank" && event?.type === "approve") {
      approveBank()
    }
  };

  useEffect(() => {
    if (isEmpty(data?.uuid)) return;
    // getkycData(data?.uuid);
    setLoader(true);
    Promise.all([
      getKucDetails(data?.uuid),
      getKycStatus(data?.uuid),
      getParentDetails(data?.userName),
      getBankDetails(data?.userName)
    ])
      .then(async ([userRes, postsRes, parentData_,bankResp]) => {
        setLoader(false);
        if (userRes?.data?.success) {
          console.log("userdetails------",userRes?.data )
          const dataList = userRes?.data?.data?.[data?.uuid] || [];
          const convertedObject = dataList.reduce((acc, item) => {
            acc[item.idType] = item;
            return acc;
          }, {});

          
          setKycData(convertedObject);
        }else{
          setKycData({});
        }

        if (postsRes?.data?.success) {
          setKyceStatus(postsRes?.data?.data?.kycComplete);
        }

        if (parentData_?.data?.success) {
          if (!isEmpty(parentData_?.data?.data)) {
            const distributors = parentData_?.data?.data.filter(
              (user) => user.userRole === "ROLE_DISTRIBUTOR"
            );

            setParentData(distributors?.[0] || {});
          }
        }else{
          setParentData({});
        }
      
        if(bankResp?.data.success){
          
          setBackDetails(bankResp?.data?.data || {})
        }else{
          setBackDetails({})
        }
       
      })
      .catch((error) => {
        setLoader(false);
        console.error("Error fetching data:", error);
      });
  }, [data?.uuid, reload]);

  const approveKyc = () => {
    setEventType(null);
    setLoader2(true);
    const param = { userId: data?.uuid };
    KycApprove(param)
      .then((resp) => {
        setLoader2(false);
        if (resp?.data?.success) {
          setMsg({ type: "success", msg: resp?.data?.message });
          setReload(!reload);
        } else {
          const msg = resp?.data?.message;
          if (resp?.data?.errorCodeList?.length) {
            msg = resp?.errorCodeLis.toString();
          }
          setMsg({ type: "error", msg: msg });
        }
      })
      .catch((error) => {
        console.log("KycApprove", error);
        setEventType(null);
        setLoader2(false);
      });
  };
  const rejectKyc = () => {
    setEventType(null);
    setLoader2(true);
    const param = { userId: data?.uuid };
    KycReject(param)
      .then((resp) => {
        setLoader2(false);
        if (resp?.data?.success) {
          setMsg({ type: "success", msg: resp?.data?.msg });
          setReload(!reload);
        } else {
          const msg = resp?.data?.msg;
          if (resp?.data?.errorCodeList?.length) {
            msg = resp?.errorCodeLis.toString();
          }
          setMsg({ type: "error", msg: msg });
        }
      })
      .catch((error) => {
        setEventType(null);
        setLoader2(false);
      });
  };

  const approveBank = () => {
    setEventType(null);
    setLoader2(true);


    getApproveBank(backDetails?.beneId)
      .then((resp) => {
        setLoader2(false);
        if (resp?.data?.success) {
          setMsg({ type: "success", msg: resp?.data?.msg });
          setReload(!reload);
        } else {
          const msg = resp?.data?.msg;
          if (resp?.data?.errorCodeList?.length) {
            msg = resp?.errorCodeLis.toString();
          }
          setMsg({ type: "error", msg: msg });
        }
      })
      .catch((error) => {
        console.log("KycApprove", error);
        setEventType(null);
        setLoader2(false);
      });
  };
  const rejectBank = () => {
    setEventType(null);
    setLoader2(true);
    getRejectBank(backDetails?.beneId)
      .then((resp) => {
        setLoader2(false);
        if (resp?.data?.success) {
          setMsg({ type: "success", msg: resp?.data?.msg });
          setReload(!reload);
        } else {
          const msg = resp?.data?.msg;
          if (resp?.data?.errorCodeList?.length) {
            msg = resp?.errorCodeLis.toString();
          }
          setMsg({ type: "error", msg: msg });
        }
      })
      .catch((error) => {
        setEventType(null);
        setLoader2(false);
      });
  };

  const handleInput = (e, key = "") => {
    const value = e.target.value;
    if (!isNumber(value) && !isEmpty(value)) return;
    setDistributor({});
    setDistributorMobile(value);
    if (value.length === 10) {
      getDestributer(value);
    }
  };

  const getDestributer = async (mobile) => {
    const param = {
      fromDate: "",
      toDate: "",
      username: mobile,
      name: "",
      userType: "ROLE_DISTRIBUTOR",
    };

    const pagination = {
      currentPage: 0,
      pageSize: 1,
    };
    setPopupLoader(true);
    getUserList(param, pagination).then((resp) => {
      setPopupLoader(false);
      if (resp?.data.success) {
        if (resp?.data?.data?.content && resp?.data?.data?.content?.length) {
          setDistributor(resp?.data?.data?.content[0]);
        }
      }
    });
  };

  const parentUpdate = () => {

    setLoader(true);
    updateParent(data?.userName, distributor?.userName).then((resp) => {
      closePop();
      setLoader(false);
   
      if (resp?.data?.success) {
        setMsg({ type: "success", msg: resp?.data?.msg });
        setReload(!reload);
      } else {
        const msg = resp?.data?.msg;
        if (resp?.data?.errorCodeList?.length) {
          msg = resp?.errorCodeLis.toString();
        }
        setMsg({ type: "error", msg: msg });
      }
    });
  };

  const closePop = () =>{
    setDistributorMobile("");
    setDistributor({});
    setOpenPopup(false)
  }



  return (
    <div>
      {!isEmpty(event) && (
        <ModalData
          onClickCancel={() => setEventType(null)}
          onClickConfirm={confirmHandler}
          lottieOptions={defaultOptions1}
          heading1={event.msg}
        />
      )}

      <SidebarPopup close={close} title="User details">
        {loader ? (
          <>
            <DropDownBox style={{ height: "164px" }}></DropDownBox>
            <DropDownBox style={{ height: "144px" }}></DropDownBox>
            <DropDownBox style={{ height: "122px" }}></DropDownBox>
          </>
        ) : (
          <>
            {!isEmpty(msg) && (
              <AlertWrapper className={`${msg?.type} local`}>
                <span className="close" onClick={() => setMsg({})}>
                  ×
                </span>
                {msg.msg}
              </AlertWrapper>
            )}
            <DropDownBox>
              <h2>User details</h2>
              <div className="row">
                <div className="column">
                  <h4 className="title">Name</h4>
                  <span className="value">
                    {isEmpty(data?.firstName)
                      ? "NA"
                      : `${data?.firstName || ""} ${data?.lastName || ""}`}
                  </span>
                </div>
                <div className="column">
                  <h4 className="title">Mobile No.</h4>
                  <span className="value">{data?.userName || "NA"}</span>
                </div>
                <div className="column">
                  <h4 className="title">Email</h4>
                  <span className="value">{data?.email || "NA"}</span>
                </div>
                <div className="column">
                  <h4 className="title">Status</h4>
                  <div
                    className={`status ${
                      data?.status === "ACTIVE" ? "verify" : "Noverify"
                    }`}
                  >
                    {data?.status || "NA"}
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="column" style={{flexGrow:"1"}}>
                  <h4 className="title">Address</h4>
                  <span className="value">{`${(`${data?.address1 || ""} ${data?.address2 || ""}  ${data?.landmark || ""}`).trim() || "NA"}`}</span>
                </div>
               
                <div className="column">
                  <h4 className="title">Pincode</h4>
                  <span className="value">{data?.pincode || "NA"}</span>
                </div>
               
              </div>
              <div className="row mt-5">
              <div className="column">
                  <h4 className="title">Distributor Name</h4>
                  <span className="value">{parentData?.name || "NA"}</span>
                </div>
                <div className="column">
                  <h4 className="title">
                    Distributor Username{" "}
                    <span className="">
                      <button class="" style={{color:"#00baf2"}} onClick={() => setOpenPopup(true)}>
                        <i
                          class="fa-solid fa-pen-to-square update"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </span>
                  </h4>
                  <span className="value">{parentData?.username || "NA"}</span>
                </div>

              </div>
            </DropDownBox>

            <DropDownBox>
              <h2 className="flex gap-10">Aadhaar details</h2>

              <div className="row">
                <div className="column">
                  <h4 className="title">Aadhar number</h4>
                  <span className="value">
                    {kycData?.AADHAAR?.idNumber || "NA"}
                  </span>
                </div>
                <div className="column">
                  <h4 className="title">Name on aadhar</h4>
                  <span className="value">{kycData?.AADHAAR?.name || "NA"}</span>
                </div>
                <div className="column">
                  <h4 className="title">DOB</h4>
                  <span className="value">{kycData?.AADHAAR?.dob || "NA"}</span>
                </div>
                <div className="column self-center">
                  {kycData?.AADHAAR?.verified ? (
                    <div className="verify">
                      <img src={verifyIcon} alt="icon" /> Verified
                    </div>
                  ) : (
                    <div className="Noverify">
                      <img src={verifyIcon} alt="icon" />
                      Not verified
                    </div>
                  )}
                </div>
              
              </div>
              <div className="row mt-5">
              <div className="column" style={{flexGrow:"1"}}>
                  <h4 className="title">Address</h4>
                  <span className="value">{kycData?.AADHAAR?.address || "NA"}</span>
                </div>
              </div>

              <h2 className="flex gap-10 mt-10">PAN details</h2>
              <div className="row mt-10">
                <div className="column">
                  <h4 className="title">PAN number</h4>
                  <span className="value">
                    {kycData?.PAN?.idNumber || "NA"}
                  </span>
                </div>
                <div className="column">
                  <h4 className="title">Name on PAN</h4>
                  <span className="value">{kycData?.PAN?.name || "NA"}</span>
                </div>
                <div className="column">
                  <h4 className="title">DOB</h4>
                  <span className="value">{kycData?.PAN?.dob || "NA"}</span>
                </div>
                <div className="column self-center">
                  {kycData?.PAN?.verified ? (
                    <div className="verify">
                      <img src={verifyIcon} alt="icon" /> Verified
                    </div>
                  ) : (
                    <div className="Noverify">
                      <img src={verifyIcon} alt="icon" />
                      Not verified
                    </div>
                  )}
                </div>
               
                
              </div>
              <div className="row mt-5">
              <div className="column" style={{flexGrow:"1"}}>
                  <h4 className="title">Address</h4>
                  <span className="value">{kycData?.PAN?.address || "NA"}</span>
                </div>
                <div className="column self-center">
                  <div className="buttons">
                    {!kycStatus && (
                      <>
                        <button
                          disabled={loader || isEmpty(kycData) || loader2}
                          onClick={() => clickHandler("kyc details", "approve")}
                        >
                          Approve
                        </button>
                        <button
                          disabled={loader || isEmpty(kycData) || loader2}
                          onClick={() => clickHandler("kyc details", "reject")}
                        >
                          Reject
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            
            </DropDownBox>
            <DropDownBox>
              <h2>Bank details</h2>
              <div className="row">
                <div className="column">
                  <h4 className="title">Account holder</h4>
                  <span className="value">{backDetails?.accountHolderName || "NA"}</span>
                </div>
                <div className="column">
                  <h4 className="title">Bank Name</h4>
                  <span className="value">{backDetails?.bankName || "NA"}</span>
                </div>
                <div className="column self-center">
                 
                    {
                      backDetails?.status === "APPROVED"?
                      <div className="verify">
                      <img src={verifyIcon} alt="icon" /> Approved
                    </div>
                      :
                      <div className="Noverify">
                      <img src={verifyIcon} alt="icon" />
                      Not Approved
                    </div>
                     
                    }
                    
                </div>
               
              </div>
              <div className="row mt-5">
                <div className="column">
                  <h4 className="title">Ifsc Code</h4>
                  <span className="value">{backDetails?.ifsc || "NA"}</span>
                </div>
                <div className="column">
                  <h4 className="title">Account Number</h4>
                  <span className="value">{backDetails?.accountNumber || "NA"}</span>
                </div>
                <div className="column"></div>
                <div className="column self-center">
                  <div className="buttons">
                    {(backDetails?.status === "PENDING" || isEmpty(backDetails)) && <>
                      <button
                      disabled={loader2 || isEmpty(backDetails)}
                      onClick={() => clickHandler("bank", "approve")}
                    >
                      Approve
                    </button>
                    <button
                      disabled={loader2 || isEmpty(backDetails)}
                      onClick={() => clickHandler("bank", "reject")}
                    >
                      Reject
                    </button>
                    </>}
                   
                  </div>
                </div>
              </div>
            </DropDownBox>
          </>
        )}

        {openPopup && (
          <ModalPopUp>
            <div
              className="subadmin_container"
              style={{ maxWidth: "400px", marginInline: "auto" }}
            >
              <div className="">
                <div
                  className="header flex justify-between align-items"
                  style={{ marginTop: "20px" }}
                >
                  <h3>Map Distributor</h3>
                  <div
                    style={{ cursor: "pointer", maxWidth: "20px" }}
                    onClick={closePop}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.523"
                      height="19.523"
                      viewBox="0 0 19.523 19.523"
                    >
                      <g
                        id="Group_1107"
                        dataName="Group 1107"
                        transform="translate(1.414 1.414)"
                      >
                        <line
                          id="Line_147"
                          dataName="Line 147"
                          y2="23.609"
                          transform="translate(16.694 0) rotate(45)"
                          fill="none"
                          stroke="#000"
                          stroke-linecap="round"
                          stroke-width="2"
                        />
                        <line
                          id="Line_148"
                          dataName="Line 148"
                          y1="23.609"
                          transform="translate(16.694 16.694) rotate(135)"
                          fill="none"
                          stroke="#000"
                          stroke-linecap="round"
                          stroke-width="2"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="pd-30">
                  <div>
                    <lable className="filter_text fs">
                      Distributor UserName
                    </lable>
                    <div className="flex align-items form-container">
                      <div className="mg-top3">
                        <div className="mg-top3">
                          <input
                            type="text"
                            name="userName"
                            value={distributorMobile}
                            className="filter_select  fs"
                            placeholder="Enter Mobile Number"
                            onChange={(e) => handleInput(e, "number")}
                            maxLength={10}
                          ></input>
                        </div>
                      </div>
                    </div>
                    {popupLoader && (
                      <div className="mt-10" style={{ fontSize: "10px" }}>
                        Loading...
                      </div>
                    )}
                    {!popupLoader &&
                      distributorMobile.length === 10 &&
                      isEmpty(distributor) && (
                        <div className="mt-10" style={{ fontSize: "10px" }}>
                          Distributor not found
                        </div>
                      )}
                    {!isEmpty(distributor) &&
                      distributorMobile.length === 10 && (
                        <>
                          <div className="flex row">
                            <lable className=" flex fs-12 gap-10 mt-10">
                              Name:
                              <span className="blue_font fw-bold">
                                {(distributor?.firstName || "") +
                                  " " +
                                  (distributor.lastName || "")}
                              </span>
                            </lable>
                          </div>
                          <button
                            disabled={loader}
                            class="submit_btn mt-20"
                            onClick={parentUpdate}
                          >
                            Submit
                          </button>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </ModalPopUp>
        )}
      </SidebarPopup>
    </div>
  );
}

export default UserDaitalsPopup;
